<template>
  <div class="milestone-details">
    <div class="milestone-details-header">
      <slot name="header" :milestone="milestone"/>
    </div>
    <div class="milestone-details-body">
      <slot name="body" :milestone="milestone"/>
    </div>
    <div class="milestone-details-button">
      <slot name="button" :milestone="milestone"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['milestone']
  }
</script>
<style>
  .milestone-details {
    height: 100%;
  }
  .milestone-details-header {
    display: flex;
    min-height: 50px;
    align-items: center;
  }
  .milestone-details-body {
    /* border-top: 1px solid white; */
    height: calc(100% - 131px);
    padding-top: 3px;
    justify-content: center;
  }
  .milestone-details-button {
    flex-shrink: 0;
    padding-right: 3px;
    height: 75px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
</style>
